import "../assets/js/scalyr.js";

export default 'sly';